import { useForm } from "react-hook-form";
import ControlledInput from "Components/Input";
import { useTranslation } from "react-i18next";
import Button from "Components/Button";
import Space from "Components/Space";
import FlexRow from "Components/FlexRow";
import { useEffect } from "react";
import { IPrintPlacementDto } from "Apis/Models/IPrintDto";
import { useMutatePrintPlacement } from "Apis/PrintPlacementApi";

interface IProps {
    printPlacement?: IPrintPlacementDto;
    onSubmit?: (data: IPrintPlacementDto) => void;
}
const PrintPlacementForm = (props: IProps) => {
    
    const { t } = useTranslation();
    
    const { control, handleSubmit, reset } = useForm<IPrintPlacementDto>()
    const { mutateAsync, isLoading } = useMutatePrintPlacement();
    
    useEffect(() => {
        if (props.printPlacement) {
            reset(props.printPlacement);
        }
    }, [reset, props.printPlacement])
    
    const onSubmit = async(data: IPrintPlacementDto) => {
        await mutateAsync(data);
        
        if (props.onSubmit) {
            props.onSubmit(data);
        }
        
        reset();
    }
    
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Space direction={"vertical"} size={"large"}>
                <ControlledInput rules={{required: true}} name={"name"} control={control} placeholder={t('name')} />
                
                <FlexRow justify={"end"}>
                    <Button buttonType={"submit"} type={"primary"} text={t('save')} loading={isLoading} />
                </FlexRow>
            </Space>
        </form>
    )
}

export default PrintPlacementForm
